import { createContext, useContext } from 'react';
import type { TagProps } from '../types';

interface TagContext extends Pick<TagProps, 'clickableArea' | 'variant' | 'hideOnClick' | 'size'> {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDark: boolean;
}
export const TagContext = createContext<TagContext>({} as TagContext);

export const useTagContext = () => {
  const context = useContext(TagContext);
  return context;
};
